// src/components/Footer.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation('common');
  const year = new Date().getFullYear();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer style={{
      background: '#1a1a1a',
      color: '#fff',
      padding: '40px 0 20px'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: isMobile ? '0 16px' : '0 20px',
        gap: isMobile ? '30px' : '0'
      }}>
        <div style={{
          flex: isMobile ? '1' : '0 0 30%',
          textAlign: isMobile ? 'center' : 'left'
        }}>
          <h3 style={{ marginBottom: '10px', fontSize: '18px' }}>{t('brand')}</h3>
          <p style={{ marginBottom: '8px', fontSize: '14px' }}>{t('footer.schoolLabel')}</p>
          {/* Adresse sous "École de danse" */}
          <p style={{ 
            margin: 0, 
            fontSize: '14px',
            lineHeight: '1.5'
          }}>
            {t('footer.address')}
          </p>
        </div>

        <div style={{
          flex: isMobile ? '1' : '0 0 30%',
          textAlign: isMobile ? 'center' : 'center'
        }}>
          <h4 style={{ marginBottom: '12px', fontSize: '16px' }}>{t('footer.contactTitle')}</h4>
          <p style={{ margin: '6px 0', fontSize: '14px' }}>info@mkdstudio.co</p>
          <p style={{ margin: '6px 0', fontSize: '14px' }}>+32 493 88 72 88</p>
        </div>

        <div style={{
          flex: isMobile ? '1' : '0 0 30%',
          textAlign: isMobile ? 'center' : 'right'
        }}>
          <h4 style={{ marginBottom: '12px', fontSize: '16px' }}>{t('footer.followTitle')}</h4>
          <div style={{
            display: 'flex',
            gap: '15px',
            flexWrap: 'wrap',
            justifyContent: isMobile ? 'center' : 'flex-end'
          }}>
            <a 
              href="https://instagram.com/mkdstudio_" 
              target="_blank" 
              rel="noreferrer"
              style={{
                color: '#fff',
                textDecoration: 'none',
                fontSize: '14px',
                padding: '8px 0',
                display: 'inline-block',
                minWidth: '44px',
                minHeight: '44px',
                lineHeight: '44px',
                textAlign: 'center'
              }}
            >
              {t('footer.social.instagram')}
            </a>
            <a 
              href="https://facebook.com" 
              target="_blank" 
              rel="noreferrer"
              style={{
                color: '#fff',
                textDecoration: 'none',
                fontSize: '14px',
                padding: '8px 0',
                display: 'inline-block',
                minWidth: '44px',
                minHeight: '44px',
                lineHeight: '44px',
                textAlign: 'center'
              }}
            >
              {t('footer.social.facebook')}
            </a>
            <a 
              href="https://youtube.com" 
              target="_blank" 
              rel="noreferrer"
              style={{
                color: '#fff',
                textDecoration: 'none',
                fontSize: '14px',
                padding: '8px 0',
                display: 'inline-block',
                minWidth: '44px',
                minHeight: '44px',
                lineHeight: '44px',
                textAlign: 'center'
              }}
            >
              {t('footer.social.youtube')}
            </a>
          </div>
        </div>
      </div>

      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.1)',
        marginTop: '30px',
        padding: '20px 0 10px',
        textAlign: 'center'
      }}>
        <p style={{ margin: 0, fontSize: '14px' }}>
          {t('footer.copyright', { year })}
        </p>
      </div>
    </footer>
  );
};

export default Footer;